/* loaded by smart-asset */
export default "loading-logo~bhuImXFN.gif"